import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { LoginService } from '../services/login.service';

declare var require: any
const Swal = require('sweetalert2')

@Injectable({
  providedIn: "root",
})
export class termsAndConditionsGuard  {
  constructor(public router: Router, private toastr: ToastrService, private loginService: LoginService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    // Guard for user is login or not
    let status = JSON.parse(localStorage.getItem("terms_and_conditions_status")!);
    let user = JSON.parse(localStorage.getItem('user')!);

    console.log(status);
    
    
    // if (Number(user.user.accept_terms_flag == 0)) {
    //   // this.toastr.error("يجب الموافقة علي الشروط و الأحكام")
    //   Swal.fire('يجب الموافقة علي الشروط و الأحكام')
    //   this.router.navigate(["/terms-and-conditions/from-login"]);
    //   return true;
    // }
    return true;
  }
}
